import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DividerVariants from './DividerVariants';
import ClientProvider from './client';
export default createDemo(import.meta.url, DividerVariants, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/dividers/demos/variants/DividerVariants.tsx",
    "fileName": "DividerVariants.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport Divider from '@mui/material/Divider';\n\nconst style = {\n  py: 0,\n  width: '100%',\n  maxWidth: 360,\n  borderRadius: 2,\n  border: '1px solid',\n  borderColor: 'divider',\n  backgroundColor: 'background.paper',\n};\n\nexport default function DividerVariants() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <List sx={style}>\n      <ListItem>\n        <ListItemText primary=\"Full width variant below\" />\n      </ListItem>\n      <Divider component=\"li\" />\n      <ListItem>\n        <ListItemText primary=\"Inset variant below\" />\n      </ListItem>\n      <Divider variant=\"inset\" component=\"li\" />\n      <ListItem>\n        <ListItemText primary=\"Middle variant below\" />\n      </ListItem>\n      <Divider variant=\"middle\" component=\"li\" />\n      <ListItem>\n        <ListItemText primary=\"List item\" />\n      </ListItem>\n    </List>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 36,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemText from '@mui/material/ListItemText';\nimport Divider from '@mui/material/Divider';\n\nconst style = {\n  py: 0,\n  width: '100%',\n  maxWidth: 360,\n  borderRadius: 2,\n  border: '1px solid',\n  borderColor: 'divider',\n  backgroundColor: 'background.paper',\n};\n\nexport default function DividerVariants() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <List sx={style}>\n      <ListItem>\n        <ListItemText primary=\"Full width variant below\" />\n      </ListItem>\n      <Divider component=\"li\" />\n      <ListItem>\n        <ListItemText primary=\"Inset variant below\" />\n      </ListItem>\n      <Divider variant=\"inset\" component=\"li\" />\n      <ListItem>\n        <ListItemText primary=\"Middle variant below\" />\n      </ListItem>\n      <Divider variant=\"middle\" component=\"li\" />\n      <ListItem>\n        <ListItemText primary=\"List item\" />\n      </ListItem>\n    </List>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 36,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/List",
      "@mui/material/ListItem",
      "@mui/material/ListItemText",
      "@mui/material/Divider"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
